import { primaryColor } from '../locatorDriftConstants';

export const analyticsDriftTabStyles = {
  controlsPaper: {
    p: 2,
  },
  compareButton: {
    bgcolor: primaryColor,
    '&:hover': { bgcolor: '#3d2a70' },
  },
};

export const analyticsSummaryColors = {
  passed: '#16a34a',
  regressions: '#dc2626',
  otherChanges: '#d97706',
};

export const analyticsTableStyles = {
  details: {
    p: 0,
  },
  clickableRow: (ignored) => ({
    cursor: 'pointer',
    opacity: ignored ? 0.55 : 1,
  }),
  impactCell: {
    maxWidth: 280,
  },
  detailCell: {
    bgcolor: '#FAFBFC',
  },
  detailAlert: {
    mb: 1,
  },
};
